<div class="main-banner-two">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="main-banner-content">
                            <h1>{{ setup.title }}</h1>
                            <p [innerHTML]="setup.subTitle"></p>
                            <div class="banner-btn">
                                <a class="default-btn-one" routerLink="/about">About Us <span></span></a>
                                <a class="default-btn" routerLink="/contact">Contact Us <span></span></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/home-two/1.png" class="wow fadeInUp" data-wow-delay="1s" alt="image">
                            <img src="assets/img/home-two/2.png" class="wow fadeInLeft" data-wow-delay="1s" alt="image">
                            <img src="assets/img/home-two/3.png" class="wow fadeInRight" data-wow-delay="1s"
                                 alt="image">
                            <img src="assets/img/home-two/4.png" class="wow fadeInUp" data-wow-delay="1s" alt="image">
                            <img src="assets/img/home-two/5.png" class="wow zoomIn" data-wow-delay="1s" alt="image">
                            <img src="assets/img/home-two/main-image.png" class="wow zoomIn" data-wow-delay="1s"
                                 alt="image">
                        </div>
                        <div class="circle-img">
                            <img src="assets/img/home-two/shape.png" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="creative-shape"><img src="assets/img/main-banner-shape/home-shape-2.png" alt="main-image"></div>
    <div class="shape-dot"><img src="assets/img/main-banner-shape/dot.png" alt="image"></div>
</div>

<section class="services-section pt-100 pb-70">
    <app-our-data-service></app-our-data-service>
</section>

<section class="about-section  pb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-image">
                    <img src="assets/img/about.png" alt="image">
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-content">
                    <span>About Us</span>
                    <h3>{{ this.setup.aboutTitle }}</h3>
                    <p [innerHtml]="setup.aboutSubTitle"></p>
                    <ul class="about-list">
                        <li><i class="flaticon-tick"></i> Project Management</li>
                        <li><i class="flaticon-tick"></i> Value Engineering</li>
                        <li><i class="flaticon-tick"></i> Program Management</li>
                        <li><i class="flaticon-tick"></i> Owner’s Representation</li>
                    </ul>
                    <div class="about-btn">
                        <a class="default-btn" routerLink="/about">Read More <span></span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="fun-facts-area ptb-100">
    <app-counting></app-counting>
</section>
<section class="process-section pt-100">
    <app-our-process-projects></app-our-process-projects>
</section>
<section class="software-section pt-100 pb-100">
    <app-our-working-process></app-our-working-process>
</section>


<section class="testimonial-section ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Testimonial</span>
            <h3>What Our Services Say</h3>
        </div>
        <div class="testimonial-slider owl-carousel owl-theme">
            <div class="testimonial-single-item">

                <div class="testimonial-info">
                    <h3>Planning</h3>

                </div>
                <div class="testimonial-content">
                    <div class="icon">
                        <i class="flaticon-quote"></i>
                    </div>
                    <p>Planning processes can vary depending on the specific project and organization, but here is a
                        general outline of steps involved in the planning process</p>

                </div>
            </div>
            <div class="testimonial-single-item">

                <div class="testimonial-info">
                    <h3>Design & Execution</h3>

                </div>
                <div class="testimonial-content">
                    <div class="icon">
                        <i class="flaticon-quote"></i>
                    </div>
                    <p>In the construction industry, design and execution processes are crucial for the successful
                        completion of projects. These processes involve several stages and require coordination between
                        various stakeholders. Here's an overview of the typical design and execution processes in
                        construction</p>


                </div>
            </div>
            <div class="testimonial-single-item">

                <div class="testimonial-info">
                    <h3>Analytics Projects</h3>
                </div>
                <div class="testimonial-content">
                    <div class="icon">
                        <i class="flaticon-quote"></i>
                    </div>
                    <p>Analytics projects in construction, also known as construction analytics or construction data
                        analysis, involve leveraging data and insights to improve decision-making, optimize processes,
                        and enhance project outcomes. Here's an overview of the typical processes involved in analytics
                        projects in construction</p>
                </div>
            </div>
        </div>
    </div>

    <div class="testimonial-shape"><img src="assets/img/shape/testimonial-shape-1.png" alt="main-image"></div>
    <div class="testimonial-shape-img1"><img src="assets/img/shape/testimonial-shape-2.png" alt="image"></div>
    <div class="testimonial-shape-img2"><img src="assets/img/shape/testimonial-shape-3.png" alt="image"></div>
</section>
<section class="blog-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Projects</span>
            <h3>Recent Projects</h3>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6" *ngFor="let project of projects">
                <div class="blog-item">
                    <div class="blog-image" style="width: 100%; height:300px">
                        <a routerLink="/projects-details/{{project.id}}">
                            <img style="height: 100%; width: 100%;"
                                 src="{{environment.ImageApiPath +'/'+ this.project?.attachment?.name}}"
                                 alt="{{project?.name}}">
                        </a>
                    </div>
                    <div class="single-blog-item">
                        <ul class="blog-list">
                            <li><a routerLink="/"><i class="fa fa-comments"></i> {{ project.category.name }}</a></li>

                            <li><a routerLink="/"><i
                                class="fas fa-calendar-week"></i> {{ project.createdDate |date:"dd-MM-yyyy" }}</a></li>
                        </ul>
                        <div class="blog-content">
                            <h3><a routerLink="/projects-details/{{project.id}}">{{ project.name }}</a></h3>
                            <p>{{ project.shortDescrption }}</p>
                            <div class="blog-btn">
                                <a routerLink="/projects-details/{{project.id}}" class="blog-btn-one">Read More <i
                                    class="fa fa-chevron-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="productive-section pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="productive-content">
                    <span>Let’s Get Started</span>
                    <h3>{{ setup.projectTitle }} </h3>
                    <p [innerHTML]="setup.projectSubTitle"></p>
                    <div class="productive-btn">
                        <a routerLink="/projects" class="productive-btn">Get Started Project<span></span></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="productive-image">
                    <img src="assets/img/productive.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="productive-section pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="productive-content">
                    <span>Let’s Get Started</span>
                    <h3>{{ setup.valueTitle }} </h3>
                    <p [innerHTML]="setup.valueSubTitle"></p>
                    <div class="productive-btn">
                        <a routerLink="/projects" class="productive-btn">Get Started Project<span></span></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="productive-image">
                    <img src="assets/img/productive.png" alt="image">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="partner-section pt-100 pb-70">
    <div class="container">
        <div class="partner-title">
            <span>Customer</span>
            <h3>Discover Customer Successful Stories</h3>
        </div>
        <div class="partner-list">
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/1.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/2.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/3.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/4.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/5.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/6.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/7.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/8.png" alt="image"></a>
            </div>
            <div class="partner-item">
                <a routerLink="/"><img src="assets/img/partner/1.png" alt="image"></a>
            </div>
        </div>
    </div>

    <div class="partner-shape"><img src="assets/img/shape/partnar-shape-1.png" alt="main-image"></div>
    <div class="partner-shape-img1"><img src="assets/img/shape/partnar-shape-2.png" alt="image"></div>
</section>


